import { render } from "./ProductPage.vue?vue&type=template&id=0fdeb728&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=0fdeb728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdeb728"]])

export default __exports__